import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedService } from '../../../shared/shared.service';
import { DevoteePrasadOrderVM } from '../../models/devotee-prasad-order-vm';
import { AdminPrasadOrderService } from '../../services/admin-prasad-order.service';
import * as XLSX from 'xlsx';
import { AdminPrasadOrderVM } from '../../models/admin-prasad-order-vm';

@Component({
  selector: 'app-post-office-report',
  templateUrl: './post-office-report.component.html',
  styleUrls: ['./post-office-report.component.css'],
  providers: [AdminPrasadOrderService]
})
export class PostOfficeReportComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private adminPrasadOrderService: AdminPrasadOrderService) { }

  searchForm: FormGroup;
  adminPrasadOrderVMList: AdminPrasadOrderVM[] = [];
  errorMessage: string = "";
  successMessage: string = "";


  ngOnInit() {

    // this.Search();
    this.createSearchForm();
  }

  Search() {

    let searchGridEntity = { ...this.searchForm.value };
    searchGridEntity.PageNo = 0;
    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchGridEntity).subscribe(
      data => {
        this.adminPrasadOrderVMList = data.PrasadOrderVidhis.PageData;
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  exportToExcel() {
    let element = document.getElementById('dispatch-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'PostOfficeReport.xlsx')
  }

  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      DispatchStartDate: [],
      DispatchEndDate: []
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/admin/components/post-office-report/post-office-report.component.ts